import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreCustomersCurrentGetAsyncSlice } from './get';
import { coreCustomersCurrentFeatureFlagsReducers, coreCustomersCurrentFeatureFlagsWatchers } from './feature-flags';

export const coreCustomersCurrentReducers = combineReducers({
	featureFlags: coreCustomersCurrentFeatureFlagsReducers,
	get: coreCustomersCurrentGetAsyncSlice.asyncReducers
});

export const coreCustomerCurrentWatchers = combineAllWatchers([
	coreCustomersCurrentFeatureFlagsWatchers,
	coreCustomersCurrentGetAsyncSlice.asyncWatchers
]);
